import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
export function GuaranteeSection() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-20" data-id="element-144" data-mp="4vrxnq5jjzn6">
      <div className="mx-auto max-w-3xl" data-id="element-145" data-mp="9u39u7jb6m8k">
        <div className="rounded-3xl border-2 border-gold bg-white p-7 sm:p-12" data-id="element-146" data-mp="9t1n35sxkbb0">
          <div className="flex flex-col items-center text-center" data-id="element-147" data-mp="eu8ydeua7smf">
            <div className="flex h-28 w-28 flex-col items-center justify-center rounded-full bg-ink text-gold ring-4 ring-gold ring-offset-4 ring-offset-white" data-id="element-148" data-mp="jt26ssupotfq">
              <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-149" data-mp="nrrk6lfr2azd" />
              <span className="mt-1 font-serif text-2xl font-black leading-none text-white" data-id="element-150" data-mp="sldxmftqmiw8">7</span>
              <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-151" data-mp="xjfin6aq4sac">Days</span>
            </div>
            <h2 className="mt-7 font-serif text-[28px] font-black leading-tight text-ink sm:text-4xl" data-id="element-152" data-mp="12kv3oycwiysq">My 7-day “try it for yourself” guarantee</h2>
          </div>

          <div className="mt-6 space-y-3 text-[16px] leading-relaxed text-ink/80" data-id="element-153" data-mp="25s6zgbyoh357">
            <p data-id="element-154" data-mp="20saxei9jjlsa">I don’t want you buying this because I wrote a clever sales page.</p>
            <p data-id="element-155" data-mp="1vtrb2gr1c7ze">
              I want you to open the system. Read the volumes. Try the exercises. Use the trackers. Walk through the 28-day structure. <strong className="text-ink" data-id="element-156" data-mp="1rt7bz7mwiuam">And then decide for yourself.</strong>
            </p>
            <p data-id="element-157" data-mp="2ohdadct8cqgg">
              If within the first 7 days you don’t feel that The Sexual Control Protocol™ gives you a clearer, more practical way to approach your personal training and awareness, contact us and request a refund according to the purchase terms.
            </p>
            <p className="font-semibold text-ink" data-id="element-158" data-mp="2arjnh01acg9d">No complicated process. No need to justify yourself.</p>
          </div>
        </div>

        <div className="mt-10" data-id="element-159" data-mp="379pnmulf9c5d">
          <CtaButton label="Try the system risk-free" data-id="element-160" data-mp="37ar093i366p7" />
        </div>
      </div>
    </section>;
}